"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const hb_icon_colors_1 = __importStar(require("./hb-icon-colors"));
const HBIcon = (_a) => {
    var { color = hb_icon_colors_1.default.charcoal40, children, onClick } = _a, props = __rest(_a, ["color", "children", "onClick"]);
    const _props = isClickable(Object.assign(Object.assign({}, props), { onClick }))
        ? Object.assign(Object.assign({}, props), { tabIndex: 0, role: 'button', onClick, onKeyPress: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    onClick === null || onClick === void 0 ? void 0 : onClick(e);
                }
            } }) : props;
    return (react_1.default.createElement(exports.Icon, Object.assign({ color: color }, _props), children));
};
exports.default = HBIcon;
const isClickable = ({ isDisabled, onClick }) => !isDisabled && !!onClick;
// -------------------------- Styles -------------------------- //
exports.Icon = styled_components_1.default.i `
    line-height: 1;

    ${clickableStyles}

    ${({ useDefaultFill, color }) => !useDefaultFill &&
    (0, styled_components_1.css) `
            svg * {
                fill: ${color};
            }
        `}
`;
function clickableStyles({ color, hoverColor, onClick }) {
    if (!onClick) {
        return null;
    }
    if (hoverColor) {
        return getClickableStyles(hoverColor);
    }
    const colorEntry = Object.entries(hb_icon_colors_1.default).find(([_, _color]) => color === _color);
    const nextColorKey = (0, hb_icon_colors_1.nextColorInScale)(colorEntry === null || colorEntry === void 0 ? void 0 : colorEntry[0]);
    const calculatedHoverColor = nextColorKey ? hb_icon_colors_1.default[nextColorKey] : color;
    return getClickableStyles(calculatedHoverColor);
}
const getClickableStyles = (color) => (0, styled_components_1.css) `
    cursor: pointer;
    &:focus-visible {
        outline: 1px dotted #212121;
        outline: 5px auto -webkit-focus-ring-color;
    }
    &:hover svg * {
        fill: ${color};
    }
`;
//# sourceMappingURL=HBIcon.js.map